import React from 'react';
import { motion } from 'framer-motion';
import APP1SCREEN from '../../app/assets/images/projectImage/aiDoctorImage/app1Screen.webp';
import APP2SCREEN from '../../app/assets/images/projectImage/aiDoctorImage/app2Screen.webp';
import AIDOCTORBANNER from '../../app/assets/images/projectImage/aiDoctorImage/appBanner.webp';
import WEB2 from '../../app/assets/images/projectImage/aiDoctorImage/web2.webp';
import AIDoctorProjectOverview from '../organisms/ProjectsList/AIDoctorProject/AIDoctorProjectOverview';
import AIDoctorProjectContent from '../organisms/ProjectsList/AIDoctorProject/AIDoctorProjectContent';
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials';
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage';
import ContactHelp from '../molecules/ContactHelp/ContactHelp';
import Footer from '../organisms/Footer/Footer';

const AIDoctorPage = () => {
    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeInLeft = {
        hidden: { opacity: 0, x: -50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3
            }
        }
    };

    return (
        <div className='bg-[#1E1E1E] overflow-x-hidden relative'>
            <motion.div
                className='flex flex-col lg:flex-row items-center justify-center pt-20 sm:pt-20 md:pt-32 lg:pt-52 lg:pl-[10%] gap-4 md:gap-0 relative'
                initial="hidden"
                animate="visible"
                variants={staggerContainer}
            >
                <motion.div
                    className='w-[70%] md:w-[35%] lg:w-auto'
                    variants={fadeInLeft}
                >
                    <img src={AIDOCTORBANNER} alt='AIDoctorBanner' className='w-full h-full object-cover' />
                </motion.div>
                <motion.div
                    className='flex flex-col gap-4 w-full md:w-auto'
                    variants={staggerContainer}
                >
                    <motion.div
                        className='text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl font-bold leading-snug pl-2 sm:pl-5 text-white'
                        variants={fadeInUp}
                    >
                        AI FOR <br /> DOCTORS
                    </motion.div>
                    <motion.div
                        className='text-white p-4 sm:p-6 pr-6 sm:pr-10 md:pr-14 text-base sm:text-lg md:text-xl font-medium relative leading-7 lg:leading-8 md:leading-9'
                        style={{
                            background: 'linear-gradient(135deg, #4B4AD5 0%, #A461D8 100%)',
                        }}
                        variants={fadeInUp}
                    >
                        This app is an intelligent medical assistant designed to simplify healthcare information
                        and make it easily understandable. It allows users to ask health questions, explore
                        vaccination details, and receive clear, reliable answers instantly. Built for both mobile &
                        web, the platform offers a seamless & intuitive experience across devices. Its calm,
                        minimal interface ensures effortless navigation for users of all ages. Overall, This
                        application makes trustworthy healthcare guidance accessible anytime, anywhere.
                    </motion.div>
                </motion.div>
            </motion.div>

            <AIDoctorProjectOverview />
            <AIDoctorProjectContent />

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <AppsTestimonials color="#7F51D5" bgcolor={"bg-storyMagic"} />
            </motion.div>

            <motion.div
                className='p-4 sm:p-6 md:p-10 px-4 sm:px-16 md:px-36'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <CompanyLogoImage bgColor='bg-[#222222]' borderColor='border-[#2a2a2a]' />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
                className="px-4 sm:px-0"
            >
                <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
            </motion.div>
            <Footer />
        </div>
    )
}

export default AIDoctorPage